import type { NotificationListResponseNotificationsItemSourceSourceUser } from './notificationListResponseNotificationsItemSourceSourceUser';

export type NotificationListResponseNotificationsItemSource = {
  sourceUser?: NotificationListResponseNotificationsItemSourceSourceUser;
  /** @nullable */
  sourceUserId?: number | null;
};
